import React from 'react'
import theme from '../../../style/theme'
import { vw } from '../../../style/vw'
import { createUseStyles } from 'react-jss'

export default function StarRating ({ rating }) {
  const getStarVariant = (index) => rating >= index ? 'full' : rating >= (index - 0.5) ? 'half' : 'empty'
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <StarIcon className='w-5 h-5' variant={getStarVariant(1)} />
      <StarIcon className='w-5 h-5' variant={getStarVariant(2)} />
      <StarIcon className='w-5 h-5' variant={getStarVariant(3)} />
      <StarIcon className='w-5 h-5' variant={getStarVariant(4)} />
      <StarIcon className='w-5 h-5' variant={getStarVariant(5)} />
    </div>
  )
}

const StarIcon = ({ variant }) => {
  const classes = useStyles()
  return (
    <svg viewBox='0 0 473.486 473.486' className={classes.star}>
      {variant === 'half' && (
        <>
          <path d='M 473.486,182.028 310.657,157.907 236.783,11.178 162.671,158.616 0,184.338 117.584,299.59 91.77,462.308 236.923,385.991 384.4,460.679 357.033,298.423 Z' fill='currentColor' style={{ opacity: 0.2 }} />
          <path d='M473.486,182.028l-162.829-24.121L236.783,11.178l-74.112,147.438L0,184.338L117.584,299.59L91.77,462.308l145.153-76.317 l147.477,74.688l-27.367-162.256L473.486,182.028z M236.793,352.297V77.954l0.011-0.021l54.059,107.37l119.238,17.663 l-85.226,85.181l20.058,118.917L236.793,352.297z' fill='currentColor' />
        </>
      )}
      {variant === 'full' && (
        <path d='M 473.486,182.028 310.657,157.907 236.783,11.178 162.671,158.616 0,184.338 117.584,299.59 91.77,462.308 236.923,385.991 384.4,460.679 357.033,298.423 Z' fill='currentColor' />
      )}
      {variant === 'empty' && (
        <>
          <path d='M 473.486,182.028 310.657,157.907 236.783,11.178 162.671,158.616 0,184.338 117.584,299.59 91.77,462.308 236.923,385.991 384.4,460.679 357.033,298.423 Z' fill='currentColor' style={{ opacity: 0.2 }} />
          <path d='M 473.486,182.028 310.657,157.907 236.783,11.178 162.671,158.616 0,184.338 117.584,299.59 91.77,462.308 236.923,385.991 384.4,460.679 357.033,298.423 Z M 236.793,352.297 128.58468,413.75331 147.61386,284.5722 59.654688,200.88435 190.93045,178.83833 236.793,77.954 l 0.011,-0.021 54.059,107.37 119.238,17.663 -85.226,85.181 20.058,118.917 z' fill='currentColor' />
        </>
      )}
    </svg>
  )
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    gap: vw(2),
    [theme.breakpoints.up('md')]: {
      gap: vw(2, 'desktop')
    }
  },
  star: {
    width: vw(17),
    height: vw(17),
    [theme.breakpoints.up('md')]: {
      width: vw(17, 'desktop'),
      height: vw(17, 'desktop')
    }
  }
})
